<template>
  <div>
    <div v-if="modalReady">
      <modal
        name="objectShareModal"
        width="300px"
        height="auto"
        class="front modal-share"
        :scrollable="true"
      >
        <button
          class="modal-close"
          type="button"
          data-ident="hideShareModal"
          @click="$modal.hide('objectShareModal')"
        >
          <i class="icon"><icon-times /></i>
        </button>
        <div class="modal-header">
          <h4 class="text-center">
            {{ $t('common:shareButtons.shareObject') }}
          </h4>
        </div>
        <div class="modal-body">
          <!-- eslint-disable max-len -->
          <social-share-buttons
            v-if="sslbMixin_shareButtonsReady"
            :class-name="'share-modal'"
            :build-link-fb="sslbMixin_LinkBuilder('https://www.facebook.com/sharer.php?u=', 'facebook')"
            :build-link-fb-msg="sslbMixin_LinkBuilder('fb-messenger://share/?link=','facebook-messenger')"
            :build-link-twitter="sslbMixin_LinkBuilder(`https://twitter.com/intent/tweet?text=${$t('common:share.text',{clientname:clientname})}%20`)"
            :build-link-wa-mobile="sslbMixin_LinkBuilder(`https://api.whatsapp.com/send?text=${$t('common:share.text',{clientname:clientname})}%20`,'whatsapp')"
            :build-link-sms="sslbMixin_LinkBuilder(`sms:/?&body=${$t('common:share.text',{clientname:clientname})}${objectData.title} %20`,'sms')"
            :build-link-email="sslbMixin_eMailLink"
            :object-data="objectData"
            :spaced="true"
          />
          <!-- eslint-enable max-len -->
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import SocialShareButtons from 'components/SocialShareButtons.vue';
import SocialShareLinkBuilder from 'mixins/SocialShareLinkBuilder';

import IconTimes from 'ICON:IconTimes';

export default {
  name: 'ObjectShareModal',
  components: {
    SocialShareButtons,
    IconTimes,
  },
  mixins: [SocialShareLinkBuilder],
  data() {
    return {
      modalReady: false,
      shareModalClosed: false,
    };
  },
  computed: {
    objectData() {
      return this.$store.getters.getActiveObjectData;
    },
    clientname() {
      if (this.$store.getters.getPartnerConfigValue('partnerName') !== '') return this.$store.getters.getPartnerConfigValue('partnerName').replace('&', 'und');
      return process.env.CLIENTNAME;
    },
  },
  mounted() {
    this.modalReady = true;
  },
};

</script>
<style lang="scss" scoped>
  .front{
  //used to get the modal in front of other elements
    z-index: 2003;
  }
  .modal-close {
    top: -6px;
  }
  .modal-header {
    display: block;
    padding: 0;
    h4 {
      margin: 1em;
    }
  }
</style>
